import { formatDate } from "@progress/kendo-intl";
import { useEffect, useState } from "react";

interface IRouteTotalAbstract {
  totalabstract: any;
}

export const PrepareIndentTotalAbstract = (props: IRouteTotalAbstract) => {
  const { totalabstract } = props;
  console.log("Total Abstract Data:", totalabstract);
  const [totalabstractcolumns, setTotalAbstractColumns] = useState<string[]>([]);
  const [totalabstractgridData, setTotalAbstractGridData] = useState<any[]>([]);

  useEffect(() => {
    if (totalabstract?.totalabstractheader?.length > 0) {
      const columnHeaders: string[] = Object.values(
        totalabstract.totalabstractheader[0]
      ) as string[];
      setTotalAbstractColumns(columnHeaders);
    }
  }, [totalabstract]);
  
  useEffect(() => {
    if (
      totalabstract?.totalabstract?.length > 0 &&
      totalabstractcolumns.length > 0
    ) {
      console.log("Total Abstract Table Data:", totalabstract.totalabstract);
  
      const transformedData = totalabstract.totalabstract.map(
        (row: Record<string, any>) => {
          let newRow: Record<string, any> = {};
          Object.keys(row).forEach((key, index) => {
            newRow[totalabstractcolumns[index]] = row[key]; // Ensure columns exist before mapping
          });
          return newRow;
        }
      );
  
      setTotalAbstractGridData(transformedData);
      console.log("griddata", transformedData); // Now it should be correct
    }
  }, [totalabstract, totalabstractcolumns]); // Depend on totalabstractcolumns too!
  

  return (
    <>
      <div>
        <table
          style={{
            width: "100%",
            borderRadius: "10px",
            marginBottom: "10px",
            borderColor: "#E5E4E2",
            backgroundColor: "#E5E4E2",
          }}
          border={0}
          cellPadding={15}
          cellSpacing={15}
        >
          <tbody>
            <tr>
              <th>Milk:</th>
              <td>{totalabstract?.totaldetails?.[0]?.milk}</td>
              <th>Fermented Milk:</th>
              <td>{totalabstract?.totaldetails?.[0]?.fermented}</td>
              <th>Order Date:</th>
              <td>
                {formatDate(
                  new Date(totalabstract?.totaldetails?.[0]?.orderdate),
                  "dd-MM-yyyy"
                )}
              </td>
              <th>Ordered Customer:</th>
              <td>{totalabstract?.totaldetails?.[0]?.orderedcustomer}</td>
              <th>Ordered Routes:</th>
              <td>{totalabstract?.totaldetails?.[0]?.orderedroutes}</td>
              <th>Shift:</th>
              <td>{totalabstract?.totaldetails?.[0]?.shift}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        {totalabstractgridData.length > 0 && totalabstractcolumns.length > 0 ? (
          <table
            style={{
              width: "100%",
              borderRadius: "5px",
              marginBottom: "10px",
              borderColor: "#E5E4E2",
              borderCollapse: "collapse",
            }}
            border={1}
            cellPadding={10}
            cellSpacing={0}
          >
            <thead>
              <tr style={{ backgroundColor: "#E5E4E2" }}>
                {totalabstractcolumns.map((col, index) => (
                  <th
                    key={index}
                    style={{
                      padding: "10px",
                      textAlign: index === 0 ? "left" : "right",
                    }}
                  >
                    {index === 0 ? "CATEGORY" : col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {totalabstractgridData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {totalabstractcolumns.map((col, colIndex) => (
                    <td
                      key={colIndex}
                      style={{
                        padding: "10px",
                        textAlign: colIndex === 0 ? "left" : "right",
                      }}
                    >
                      {row[col] || ""}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          null
        )}
      </div>
    </>
  );
};
